function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m384 368h-256c-8.837 0-16-7.164-16-16v-144c0-79.402 64.598-144 144-144s144 64.598 144 144v144c0 8.836-7.163 16-16 16zm-240-32h224v-128c0-61.757-50.243-112-112-112s-112 50.243-112 112z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m384 432h-256c-26.467 0-48-21.533-48-48s21.533-48 48-48h256c26.467 0 48 21.533 48 48s-21.533 48-48 48zm-256-64c-8.822 0-16 7.178-16 16s7.178 16 16 16h256c8.822 0 16-7.178 16-16s-7.178-16-16-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 96c-8.837 0-16-7.164-16-16v-40c0-22.056 17.944-40 40-40s40 17.944 40 40c0 8.836-7.163 16-16 16s-16-7.164-16-16c0-4.411-3.589-8-8-8s-8 3.589-8 8v40c0 8.836-7.163 16-16 16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 512c-35.29 0-64-28.71-64-64 0-15.784 5.795-30.941 16.316-42.68 3.035-3.386 7.367-5.32 11.914-5.32h71.539c4.547 0 8.879 1.935 11.914 5.32 10.522 11.739 16.317 26.896 16.317 42.68 0 35.29-28.71 64-64 64zm-27.716-80c-2.79 4.824-4.284 10.33-4.284 16 0 17.645 14.355 32 32 32s32-14.355 32-32c0-5.67-1.494-11.176-4.284-16z"
}));

var SvgNotification = function SvgNotification(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification.e71430ae.svg";
export { ForwardRef as ReactComponent };